<div id="reset-password" fxLayout="column" fusePerfectScrollbar>

  <div class="language-switcher">
    <button mat-button class="lang-btn" [class.active]="currentLang === 'en'" (click)="setLanguage('en')">EN</button>
    <button mat-button class="lang-btn" [class.active]="currentLang === 'de'" (click)="setLanguage('de')">DE</button>
  </div>

  <div id="reset-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center"
    *fuseIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

    <div id="reset-password-form">

      <div [ngClass]="{'logo-def' : logoUrl === 'assets/images/logos/fuse.svg',
      'logo':  logoUrl !== 'assets/images/logos/fuse.svg'}">
        <img src="{{logoUrl}}">
      </div>

<!--      <div class="title">{{'resetPass.set_password' | translate }}</div>-->

      <form name="resetPasswordForm" [formGroup]="resetPasswordForm" novalidate>
        <mat-form-field>
          <input matInput placeholder="E-Mail" formControlName="email">
          @if (resetPasswordFormErrors.email.required) {
            <mat-error>
              {{'resetPass.email_required' | translate}}
            </mat-error>
          }
          @if (!resetPasswordFormErrors.email.required && resetPasswordFormErrors.email.email) {
            <mat-error>
              {{'resetPass.valid_email_error' | translate}}
            </mat-error>
          }
        </mat-form-field>
          <div class="password-requirements">
            <p class="requirements-title">{{'resetPass.password_requirements_title' | translate}}</p>
            <ul class="requirements-list">
              <li [ngClass]="{'valid': hasMinLength, 'no-valid': !hasMinLength}">
                <mat-icon class="req-icon">{{ hasMinLength ? 'check' : 'close' }}</mat-icon>
                <span>{{'resetPass.password_requirement_length' | translate}}</span>
              </li>
              <li [ngClass]="{'valid': hasNumber, 'no-valid': !hasNumber}">
                <mat-icon class="req-icon">{{ hasNumber ? 'check' : 'close' }}</mat-icon>
                <span>{{'resetPass.password_requirement_number' | translate}}</span>
              </li>
              <li [ngClass]="{'valid': hasSpecialChar, 'no-valid': !hasSpecialChar}">
                <mat-icon class="req-icon">{{ hasSpecialChar ? 'check' : 'close' }}</mat-icon>
                <span>{{'resetPass.password_requirement_special' | translate}}</span>
              </li>
            </ul>
          </div>
        <div class="password-wrapper">
          <mat-form-field>
            <input type="password" matInput placeholder="Passwort" formControlName="password"
                   id="password">
            @if (resetPasswordFormErrors.password.required) {
              <mat-error>
                {{'resetPass.password_required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <img (click)="showPass()" class='eye' src="assets/images/eye.svg">
        </div>

        <mat-form-field>
          <input type="password" matInput placeholder="Passwort (wiederholen)"
                 formControlName="passwordConfirm" id="confirmPassword">
          @if (resetPasswordFormErrors.passwordConfirm.required) {
            <mat-error>
              {{'resetPass.password_confirm_required' | translate}}
            </mat-error>
          }
        </mat-form-field>

        <button mat-raised-button class="submit-button" color="accent" (click)="changePass()"
          aria-label="RESET MY PASSWORD" [disabled]="resetPasswordForm.invalid">
          {{'resetPass.confirm_password' | translate}}
        </button>
      </form>

      <div class="login" fxLayout="row" fxLayoutAlign="center center">
        <a class="link" [routerLink]="'/pages/auth/login'">{{'resetPass.back_to_login' | translate}}</a>
      </div>

    </div>

  </div>

</div>
